import { Controller } from "@hotwired/stimulus"
import { useEcharts } from "../../../mixins/useEcharts";
import { colorStops, axisLabelFormatter, idlingNeedle, revving } from "../../../lib/charts/gauge_moi.js";

// Connects to data-controller="chart--guage--moi"
export default class extends Controller {

  static values = {
    options: { type: Object},
    scale: Boolean,
    loading: Boolean
  }

  connect() {
    useEcharts(this);
    this.chart = this.initializeChart(this.element);
    this.draw();
    if (this.scaleValue) {
      this.resize = () => {
        if (this.chart) {
          this.chart.resize();
          this.chart.setOption(this.options());
        }
      };
      this.windowResize = this.resize;
    }
  }

  optionsValueChanged() {
    this.draw();
  }

  loadingValueChanged() {
    this.draw();
  }

  // Replacing rather than merging drops the loading settings, and the needle swings on from where it stands.
  draw() {
    if (!this.chart) return;
    clearTimeout(this.needleStep);
    this.chart.setOption(this.options(), { notMerge: true });
    if (this.loadingValue && !this.reducedMotion) {
      this.revs = revving();
      this.rev();
    }
  }

  // Each move sets its own speed and easing. Ends on its own once the chart is disposed.
  rev = () => {
    if (!this.chart) return;
    const { value, duration, easing, after } = this.revs.next().value;
    this.chart.setOption({ series: [{ data: [{ value }], animationDurationUpdate: duration, animationEasingUpdate: easing }] });
    this.needleStep = setTimeout(this.rev, after);
  }

  get reducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  options() {
    const options = this.optionsValue;
    options.series[0].axisLine.lineStyle.color = colorStops;
    options.series[0].axisLabel.formatter = axisLabelFormatter;
    if (this.loadingValue) idlingNeedle(options.series[0]);
    if (this.scaleValue) {
      const scale = this.element.clientWidth / 384;
      const series = options.series[0];
      for (const [part, properties] of [
        [series.axisLine.lineStyle, ['width']],
        [series.pointer, ['width']],
        [series.axisTick, ['length', 'distance']],
        [series.axisTick.lineStyle, ['width']],
        [series.splitLine, ['length', 'distance']],
        [series.splitLine.lineStyle, ['width']],
        [series.axisLabel, ['fontSize', 'distance']],
        [series.detail, ['fontSize']]
      ]) {
        for (const property of properties) part[property] *= scale;
      }
    }
    if (this.reducedMotion) {
      options.animation = false;
      options.series[0].detail.valueAnimation = false;
      // A still needle would read as a figure.
      options.series[0].pointer.show = !this.loadingValue;
    }
    return options;
  }

}
